"use client";

import { OptionType } from '@/shared/types/types';
import { ScrollReveal } from '../ScrollReveal';
import styles from './AutoScrollCarousel.module.scss';
import { useTranslations } from 'next-intl';

interface AutoScrollCarouselProps {
  data: OptionType[];
  tKey: string;
  icon?: JSX.Element;
  width?: string;
  isTranslated?: boolean;
}

export function AutoScrollCarousel({ data, tKey, width, icon, isTranslated=true }: AutoScrollCarouselProps) {
  const t = useTranslations(tKey);

  return (
    <div className={styles.carousel}>
      <ScrollReveal variant="fadeUp" className={styles.formats}>
        {data.concat(data).map((item, i) => (
          <section key={i}
            className={styles.formats_item}
            style={{ width }}
          >
            <div className={styles.formats_item_title}>
              <h6>{isTranslated ? t(item.title) : item.title}</h6>
              {item.icon ? item.icon : icon}
            </div>
            <p>{isTranslated ? t(item?.desc) : item?.desc}</p>
          </section>
        ))}
      </ScrollReveal>
    </div>
  );
}
